import Modal from "../../../../modal/Modal";
import { StyledTableWrapper } from "../../../main/DataTableStyles";
import { useLanguageContext } from "../../../../../context/LanguageContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";

function QuestionAnswersView({ onClose, questionAnswers = [] }) {
  const { translateEntity, translate } = useLanguageContext();

  return (
    <Modal onClose={onClose} title={translate("eva.main.entities.questions")}>
      <StyledTableWrapper>
        <table>
          <tbody>
            {questionAnswers.map((qa) => (
              <tr key={`${qa.question.id}-${qa.answer.id}`}>
                <td>{translateEntity(qa.question, "question")}:</td>
                <td>{translateEntity(qa.answer, "answer")}</td>
                <td>
                  <FontAwesomeIcon
                    icon={qa.answer.correct ? faCheck : faXmark}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </StyledTableWrapper>
    </Modal>
  );
}

export default QuestionAnswersView;
